export class FeatureFlag {
  public imageUploadQuestion: boolean;
  appointmentSystem: boolean;
}
